export default __webpack_public_path__ + "static/social-medias-bg-817d34d2e3fd6d40ea56add83a01346e.png";